export const locale = {
    lang: 'en',
    data: {
        'HEADERS': {
            'OfferAbove': 'Offer above'
        },
        'FIELDS': {
            'Kr': 'Kr.'
        },
        'BUTTONS': {
            'Save': 'Save',
            'Back': 'Back',
        },
        'MESSAGES': {
            'Failed': 'Operation failed , try later',
            'Success': 'Success'
        }
    }
}